import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A modern street lamp: a tapered steel column with a curved bracket arm and a
// cobra-head luminaire angled down over the road, its lens lit warm. The basic
// unit of street lighting.
const POLE = "#8a9097";
const POLE_DK = "#6c727a";
const HEAD = "#5f656b";
const LENS = "#ffe08a";

export const streetLight = defineModel({
  id: "street-light",
  batchId: "electric",
  name: "Street light",
  tags: ["prop", "electric", "power", "lighting", "lamp", "street"],
  summary: "A steel street light with a cobra-head luminaire.",
  footprint: 0.4,
  parts(): Part[] {
    return [
      // Base and column.
      { geometry: new THREE.CylinderGeometry(0.09, 0.11, 0.1, 10), color: POLE_DK, position: [0, 0.05, 0] },
      { geometry: new THREE.CylinderGeometry(0.04, 0.07, 1.6, 10), color: POLE, position: [0, 0.9, 0] },
      // Curved bracket arm reaching out over +Z.
      { geometry: new THREE.BoxGeometry(0.05, 0.05, 0.34), color: POLE, position: [0, 1.68, 0.14], rotation: [-0.5, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.05, 0.2), color: POLE, position: [0, 1.76, 0.32] },
      // Cobra-head luminaire, angled slightly down.
      { geometry: new THREE.BoxGeometry(0.16, 0.07, 0.3), color: HEAD, position: [0, 1.74, 0.46], rotation: [0.12, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.13, 0.03, 0.22), color: LENS, position: [0, 1.69, 0.47], rotation: [0.12, 0, 0] },
    ];
  },
  animations: [],
});
